import { InfoIcon } from 'lucide-react';

import { Tooltip, TooltipContent, TooltipTrigger, TooltipProvider } from '@/components/ui/tooltip';

const RoleTooltip = () => {
  return (
    <TooltipProvider delayDuration={100}>
      <Tooltip>
        <TooltipTrigger asChild>
          <InfoIcon className="size-4 text-muted-foreground" />
        </TooltipTrigger>
        <TooltipContent side="left" align="center" className="max-w-96">
          Each role defines what a member can do within your organization. Product-level permissions are set separately
          within each product.
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};

export default RoleTooltip;
